import { render } from "./CatalogCheck.vue?vue&type=template&id=456a8a30&scoped=true&ts=true"
import script from "./CatalogCheck.vue?vue&type=script&lang=ts"
export * from "./CatalogCheck.vue?vue&type=script&lang=ts"

import "./CatalogCheck.vue?vue&type=style&index=0&id=456a8a30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456a8a30"]])

export default __exports__